/**
 * @generated SignedSource<<1088343515e7a20628b21854e63d91d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type userInfoQuery$variables = Record<PropertyKey, never>;
export type userInfoQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly birthDay: string | null | undefined;
      readonly indis: ReadonlyArray<{
        readonly tin: string;
      }> | null | undefined;
      readonly name: string | null | undefined;
      readonly phone: string | null | undefined;
    };
  };
};
export type userInfoQuery = {
  response: userInfoQuery$data;
  variables: userInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "birthDay",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tin",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "userInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "userInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a488dee82cb8ca9dd3aa2a3746188aa",
    "id": null,
    "metadata": {},
    "name": "userInfoQuery",
    "operationKind": "query",
    "text": "query userInfoQuery {\n  bznavRefund {\n    user {\n      name\n      phone\n      birthDay\n      indis {\n        tin\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eeec177f77f5d5e645241e6e24f4b874";

export default node;
